"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrTravelDatesMobileModal = void 0;
const next_i18next_1 = require("next-i18next");
const dynamic_1 = __importDefault(require("next/dynamic"));
const react_1 = __importDefault(require("react"));
const fdr_travel_dates_skeleton_1 = require("./fdr-travel-dates.skeleton");
const fdr_mobile_modal_1 = require("./fdr-mobile-modal");
let FdrTravelDatesMobile = (0, dynamic_1.default)(() => Promise.resolve().then(() => __importStar(require('./fdr-travel-dates'))).then(module => module.FdrTravelDatesMobile), {
    loading: function mobileSkeleton() {
        return react_1.default.createElement(fdr_travel_dates_skeleton_1.FdrTravelDatesSkeletonMobile, null);
    },
});
if (process.env.NODE_ENV === 'test') {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const travelDatesModule = require('./fdr-travel-dates');
    FdrTravelDatesMobile = travelDatesModule.TravelDatesDesktop;
}
function FdrTravelDatesMobileModal({ show, closeModal, travelDatesState, travelDatesHandlers, customConfiguration, setTravelDatesData, onChange, configuration, children, className, footerChildren, title, applyText, closeOnSaveAction, }) {
    const [t] = (0, next_i18next_1.useTranslation)('search');
    return (react_1.default.createElement(fdr_mobile_modal_1.FdrMobileModal, { label: t('dates.label'), title: title, show: show, className: className, closeModal: closeModal }, travelDatesState && (react_1.default.createElement(FdrTravelDatesMobile, Object.assign({}, travelDatesHandlers, { applyText: applyText, travelDatesState: travelDatesState, customConfiguration: customConfiguration, configuration: configuration, saveTravelDates: travelDates => {
            setTravelDatesData(travelDates);
            onChange && onChange(travelDates);
            if (typeof closeOnSaveAction === 'function') {
                closeOnSaveAction();
            }
            else
                closeModal();
        }, footerChildren: footerChildren }), children))));
}
exports.FdrTravelDatesMobileModal = FdrTravelDatesMobileModal;
//# sourceMappingURL=fdr-travel-dates-mobile-modal.js.map